import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DataExtractionState } from '../extraction/extraction-reducer';
import { getDataExtractionState } from '../extraction/extraction-selectors';
import { promotionFeatureKey, PromotionState } from './promotion-reducer';

export const getFilterPromotionState = createFeatureSelector<PromotionState>(promotionFeatureKey);

export const getSelectedPromotions = createSelector(getDataExtractionState, (state: DataExtractionState) => state.selectedFilters.promotions);

export const getPromotionState = createSelector(getFilterPromotionState, (state: PromotionState) => state);
